import { useDispatch, useSelector } from 'react-redux';
import FJFake3dEdit from './FJFake3dEdit';
import FJActionFake3d from '../../../../redux/action/FJActionFake3d';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import {
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    UPLOAD_FILE_TYPE_NO_GIF,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../../config/dataConfig/FJGenerateData.js';

const FJFake3dEditContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const deepMapImage = useSelector(state => state.fake3d.deepMapImage);
    const originImage = useSelector(state => state.fake3d.originImage);
    const previewImage = useSelector(state => state.fake3d.previewImage);

    const uploadStatus = useSelector(state => state.fake3d.uploadStatus);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };
    const uploadImg = file => {
        dispatch(FJActionFake3d.uploadImageAction(file));
    };
    const cancelDepthMapTask = () => {
        dispatch(FJActionFake3d.cancelDepthMapTaskAction());
    };
    const onExport = () => {
        dispatch(FJActionFake3d.exportAction());
    };

    const _openMediaLibrary = () => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode: UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    acceptTypeNoTranscode: UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['IMAGE'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    };

    return (
        <FJFake3dEdit
            openMediaLibrary={_openMediaLibrary}
            uploadImg={uploadImg}
            uploadStatus={uploadStatus}
            deepMapImage={deepMapImage}
            originImage={originImage}
            previewImage={previewImage}
            cancelDepthMapTask={cancelDepthMapTask}
            onExport={onExport}
            isDraggingFile={isDraggingFile}
            setIsDraggingFile={setIsDraggingFile}
        />
    );
};

export default FJFake3dEditContainer;
